import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useUserApi } from "../api/UserApi";
import { toast } from "react-toastify";
import { handleApiError } from "../utils/handleApiError";

const ForgotPasswordPage: React.FC = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const { forgotPassword } = useUserApi();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const response = await forgotPassword(email);
      if (response.status === 200) {
        toast.info(response.data.message);
      } else {
        setLoading(false);
        return;
      }
    } catch (error: any) {
      handleApiError(error, "Feil i kommunikasjon med serveren.");
      setLoading(false);
      return;
    }
    navigate("/");
  };

  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen bg-orange-50 overflow-hidden">
      {/* === HEADER with logo === */}
      <header className="absolute top-0 left-0 w-full flex justify-center py-4 bg-white/80 backdrop-blur-sm shadow-sm z-30">
        <img
          src="/assets/fontenehusetlogo.webp"
          alt="Fontenehuset Logo"
          className="w-40 sm:w-48 md:w-56 opacity-95 drop-shadow-md"
        />
      </header>

      {/* === Main card area (20% higher) === */}
      <div className="flex flex-col items-center justify-center translate-y-[-20%]">
        <div className="relative z-20 bg-white/95 backdrop-blur-sm rounded-2xl shadow-lg p-10 sm:p-12 w-full max-w-sm mx-4 min-h-[450px] flex flex-col justify-center">
          <h1 className="text-3xl font-bold text-center text-orange-600 mb-3">
            Glemt passord?
          </h1>
          <p className="text-center text-gray-600 mb-8 text-sm sm:text-base leading-relaxed">
            Skriv inn e-posten din for å motta en lenke for å tilbakestille
            passordet ditt.
          </p>

          <form onSubmit={handleSubmit} className="flex flex-col gap-4">
            <div>
              <label className="block text-gray-700 font-medium mb-1">
                E-post
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-orange-400"
                placeholder="navn@eksempel.no"
                required
              />
            </div>

            {error && (
              <p className="text-red-500 text-sm text-center mt-1">{error}</p>
            )}

            <button
              type="submit"
              disabled={loading}
              className="bg-orange-500 text-white font-semibold py-2.5 rounded-lg hover:bg-orange-600 transition mt-4"
            >
              {loading ? "Sender..." : "Send lenke"}
            </button>
          </form>

          <div className="mt-6 text-center text-sm text-gray-600">
            <button
              type="button"
              className="text-orange-600 hover:underline font-medium"
              onClick={() => navigate("/")}
            >
              ← Tilbake til innlogging
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
